export const container = ({ isDesktop }) => ({
  width: "100%",
  height: "100%",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridTemplateRows: isDesktop ? "70px 1fr" : "50px 1fr",
  background: "white",
  position: "relative",
  zIndex: 40,
});

export const body = ({ isDesktop }) => ({
  overflow: "auto",

  display: "grid",
  gridTemplateColumns: !isDesktop ? "1fr" : "45% 55%",
  gridTemplateRows: "1fr",
});

export const productDetailsHeader = ({ backgroundColour = "black" }) => ({
  height: "100%",
  width: "100%",
  background: backgroundColour,
  color: "white",
  px: "20px",
});

export const introPanel = ({ isDesktop, isMobile }) => ({
  padding: !isDesktop ? "50px 100px" : "50px 50px 5px 100px",
  paddingInline: isMobile && "50px",
  display: "flex",
  flexDirection: "column",
  zIndex: "20",

  a: {
    color: "primary",
  },
});

export const mobileDivider = ({ _isMobile, _isTablet }) => ({
  width: "100%",
  // transform: isMobile && !isTablet ? "scale(1.5)" : "scale(1)",
});

export const buttonsPanel = ({ isDesktop, isMobile }) => ({
  marginTop: !isDesktop ? "0px" : "70px",
  padding: !isDesktop ? "50px 100px 100px" : "50px 100px 5px 50px",
  paddingInline: isMobile && "50px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
});

export const chooseButton = () => ({
  width: "100%",
  marginTop: "40px",
});

export const appLogo = {
  display: "block",
  width: "100%",
  maxWidth: "250px",
};

export const recipeFieldWrapper = () => ({
  marginTop: "30px",
  display: "grid",
  alignItems: "center",
  gap: "10px 20px",
  gridTemplateColumns: "max-content auto",
});

export const fetchRecipeError = () => ({
  gridColumnStart: "2",
  color: "danger",
});

export const heading = () => ({
  marginTop: "50px",
  variant: "text.h1",
  lineHeight: "60px",
  zIndex: 20,
});

export const cardsContainer = () => ({
  width: "100%",
  marginTop: "50px",
  paddingBottom: "50px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  zIndex: 20,
});

export const card = () => ({
  width: "100%",
});
